import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CreateAccountBalanceCheckRequestRequest {
  @observable
  accountingPeriodTo!: string;
}

export const CreateAccountBalanceCheckRequestValidationRules: EntityValidationRules<CreateAccountBalanceCheckRequestRequest> = {
  accountingPeriodTo: {
    required: true,
  },
};
